(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('HandbookDeleteController',HandbookDeleteController);

    HandbookDeleteController.$inject = ['$uibModalInstance', 'entity', 'Handbook'];

    function HandbookDeleteController($uibModalInstance, entity, Handbook) {
        var vm = this;

        vm.handbook = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Handbook.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
